import { Directive, Input, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { cnpjValidator } from '../validators/cnpj.validator';

@Directive({
  selector: '[cnpjAlfanumerico]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CnpjAlfanumericoDirective),
      multi: true
    }
  ]
})
export class CnpjAlfanumericoDirective implements Validator {
  @Input() cnpjAlfanumerico: any;

  validate(control: AbstractControl): ValidationErrors | null {
    return cnpjValidator(control);
  }
}
